import React, { useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import WarningIcon from "@material-ui/icons/Warning";
import logoPagueFacil from "../../assets/img/logo-pague-facil.svg";
import { isSimulatedAuthenticationEnabled } from "../../config/enviroment";
import {
  createSimulatedAuthentication,
  normalizeSimulatedDocument,
} from "../../services/simulatedAuthentication";

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: "center",
    display: "flex",
    minHeight: "100vh",
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  card: {
    margin: "0 auto",
    maxWidth: 520,
  },
  content: {
    padding: theme.spacing(4),
  },
  logo: {
    display: "block",
    margin: `0 auto ${theme.spacing(3)}px`,
    maxWidth: 230,
    width: "100%",
  },
  warning: {
    alignItems: "center",
    background: "#fff4d6",
    border: "1px solid #f0c36d",
    borderRadius: 4,
    display: "flex",
    gap: theme.spacing(1),
    margin: `${theme.spacing(2)}px 0`,
    padding: theme.spacing(2),
  },
  field: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(3),
  },
  error: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(2),
  },
}));

export default function SimulatedAccess() {
  const classes = useStyles();
  const history = useHistory();
  const [documentNumber, setDocumentNumber] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!isSimulatedAuthenticationEnabled()) {
    return <Redirect to="/" />;
  }

  const submit = async event => {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      await createSimulatedAuthentication(documentNumber);
      setSubmitting(false);
      history.replace("/");
    } catch (requestError) {
      setError(
        requestError?.response?.data?.Message ||
          requestError?.response?.data?.message ||
          requestError.message ||
          "Nao foi possivel iniciar a sessao simulada."
      );
      setSubmitting(false);
    }
  };

  return (
    <Container className={classes.root} maxWidth="sm">
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <img className={classes.logo} src={logoPagueFacil} alt="Pague Facil" />
          <Typography component="h1" variant="h5">
            Acesso simulado
          </Typography>
          <div className={classes.warning}>
            <WarningIcon color="secondary" />
            <Typography variant="body2">
              Recurso exclusivo para testes em ambiente local ou DSV. A sessao
              expira em uma hora.
            </Typography>
          </div>
          <form noValidate onSubmit={submit}>
            <TextField
              autoFocus
              className={classes.field}
              disabled={submitting}
              fullWidth
              id="simulated-document"
              inputProps={{ maxLength: 18 }}
              label="CPF ou CNPJ"
              onChange={event => setDocumentNumber(event.target.value)}
              placeholder="784.291.965-87"
              required
              value={documentNumber}
              variant="outlined"
            />
            <Typography color="textSecondary" variant="caption">
              CPF deve conter 11 digitos. CNPJ pode conter 14 caracteres
              alfanumericos.
            </Typography>
            {error && (
              <Typography className={classes.error} role="alert" variant="body2">
                {error}
              </Typography>
            )}
            <Button
              className={classes.button}
              color="primary"
              disabled={submitting || !normalizeSimulatedDocument(documentNumber)}
              fullWidth
              type="submit"
              variant="contained"
            >
              {submitting ? <CircularProgress color="inherit" size={24} /> : "Entrar"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Container>
  );
}
